import DPTextBox from "framework/components/DPTextBox"
import { Col, Row } from "reactstrap"


const CustomerMasterTab9 = ({
    references,
    rerefencesOnChange,
    disabled

}) => {

    return (<Row>
        <Col sm={12} md={6} className="mb-4-sm">
            <DPTextBox
                rowClass="mb-4-sm"
                labelText="Reference 1"
                textType="text"
                maxLength="50"
                name={"reference1"}
                value={references.reference1}
                onChange={rerefencesOnChange}
                disabled={disabled}
            />
            <DPTextBox
                rowClass="mb-4-sm"
                labelText="Reference 2"
                textType="text"
                maxLength="50"
                name={"reference2"}
                value={references.reference2}
                onChange={rerefencesOnChange}
                disabled={disabled}
            />
            <DPTextBox
                rowClass="mb-4-sm"
                labelText="Reference 3"
                textType="text"
                maxLength="50"
                name={"reference3"}
                value={references.reference3}
                onChange={rerefencesOnChange}
                disabled={disabled}
            />
            <DPTextBox
                rowClass="mb-4-sm"
                labelText="Reference 4"
                textType="text"
                maxLength="50"
                name={"reference4"}
                value={references.reference4}
                onChange={rerefencesOnChange}
                disabled={disabled}
            />
            <DPTextBox
                rowClass="mb-4-sm"
                labelText="Reference 5"
                textType="text"
                maxLength="50"
                name={"reference5"}
                value={references.reference5}
                onChange={rerefencesOnChange}
                disabled={disabled}
            />
        </Col>
    </Row>)

}
export default CustomerMasterTab9
